// extracted by mini-css-extract-plugin
export var contentWrapper = "index-module--content-wrapper--ZBaa8";
export var date = "index-module--date--vBOse";
export var dateWrapper = "index-module--date-wrapper--ohdLh";
export var link = "index-module--link--DQnWx";
export var organizer = "index-module--organizer--qo8tR";
export var organizerWrapper = "index-module--organizer-wrapper--nTebW";
export var root = "index-module--root--g88JV";
export var title = "index-module--title--2lDp+";
export var titleWrapper = "index-module--title-wrapper--mX2gm";